import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { services } from "../../data/services";


const Footer = () => {
  return (
    <footer className="bg-primary text-white relative overflow-hidden">

      <div className="container-custom py-16">

        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-10">

          {/* Company */}

          <div>

            <Link to="/" className="inline-block mb-4">
              <img
                src="/logo.png"
                alt="AZ Construction"
                className="h-20 md:h-28 w-auto object-contain bg-white rounded-xl"
              />
            </Link>

            <p className="text-gray-300 leading-7">
              Delivering trusted construction,
              development and property solutions
              with quality, integrity and innovation.
            </p>

            <div className="flex gap-4 mt-6">

              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"
              >
                <FaFacebookF />
              </a>

              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"
              >
                <FaInstagram />
              </a>

              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"
              >
                <FaLinkedinIn />
              </a>

            </div>

          </div>

          {/* Links */}

          <div>

            <h4 className="font-semibold text-xl mb-5">
              Quick Links
            </h4>

            <ul className="space-y-3">

              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <Link to="/about-us">
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/services">
                  Services
                </Link>
              </li>

              <li>
                <Link to="/projects">
                  Projects
                </Link>
              </li>

              <li>
                <Link to="/blogs">
                  Blogs
                </Link>
              </li>

              <li>
                <Link to="/contact-us">
                  Contact
                </Link>
              </li>

            </ul>

          </div>

          {/* Services */}

          <div>

            <h4 className="font-semibold text-xl mb-5">
              Services
            </h4>

            <ul className="space-y-3">
              {services.filter((service) => !service.isLocationPage).map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-gray-300 hover:text-[#F59E0B] transition"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>

          </div>

          {/* Contact */}

          <div>

            <h4 className="font-semibold text-xl mb-5">
              Contact Us
            </h4>

            <div className="space-y-5">

              <div className="flex gap-3">
                <FaMapMarkerAlt className="mt-1 text-accent" />

                <p className="text-gray-300">
                  2, Gandhi Gram Colony,
                  Near Khajrana Thana, Dargah Main Road,
                  Khajrana Indore
                </p>
              </div>

              <div className="flex gap-3">
                <FaPhoneAlt className="text-accent" />
                <p>+91 99266 66609, +91 83195 69994</p>
              </div>

              <div className="flex gap-3">
                <FaEnvelope className="text-accent" />
                <p className="break-all">
                  contact@azconstruction.com
                </p>
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* Copyright */}

      <div className="border-t border-white/10">

        <div className="container-custom py-5 flex flex-col-reverse md:flex-row justify-between gap-3 text-sm text-gray-300 items-center">
          <div className="flex flex-col md:flex-row items-center gap-2">
            © 2026 AZ Construction.
            All Rights Reserved.
            <div className="flex gap-1">
              Developed by <a
                href="https://www.navigotechinnovation.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:underline"
              >
                NavigoTech Innovation
              </a>
            </div>
          </div>

          <div className="flex gap-5">

            <Link to="/privacy-policy">
              Privacy Policy
            </Link>

            <Link to="/terms-of-service">
              Terms of Service
            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;